<div class="wrapper">
	<div class="text-container">
		<ion-row>
			<ion-col>
				<h3>{{ 'custom_tip.title' | translate }}</h3>
			</ion-col>
		</ion-row>
		<ion-row>
			<ion-col>
				<ion-item lines="none">
					<ion-label>€</ion-label>
					<ion-input
						(keypress)="numberOnlyValidation($event)"
						[(ngModel)]="customTip"
						class="primary-input"
						placeholder="{{ 'custom_tip.input_placeholder' | translate }}"
					></ion-input>
				</ion-item>
			</ion-col>
		</ion-row>
	</div>
	<ion-row>
		<ion-col class="button-block">
			<ion-button (click)="dismiss()" class="button">
				{{ 'custom_tip.button_cancel' | translate }}
			</ion-button>
			<ion-button (click)="addCustomTip()" class="button">
				{{ 'custom_tip.button_ok' | translate }}
			</ion-button>
		</ion-col>
	</ion-row>
</div>
